export const TRUCK_TYPES = [
  'BTR',
  'DRB',
  'DRV',
  'FBE',
  'RFR',
  'CGV',
  'CON',
  'CUR',
  'DDP',
  'HOT',
  'HST',
  'IMC',
  'SDK',
  'STR',
  'STK',
  'LTL',
  'BLK',
  'TNK',
  'OTH',
  'FRA',
  'SBT',
  'SPR',
  'RORO',
  'WF',
  'DT',
  'OT',
] as const

export type TruckType = (typeof TRUCK_TYPES)[number]

export const TRUCK_SUB_TYPES = [
  'regular_dryvan',
  'vented_van',
  'dryvan_or_reefer',
  'cargo_van',
  'sprinter',
  'straight_truck',
  'regular_reefer',
  'space_saver_reefer',
  'regular_flatbed',
  'conestoga',
  'step_deck',
  'hotshot',
  'double_drop',
  'gooseneck',
  'low_boy',
  'maxi',
  'power_only',
  'removable_gooseneck',
] as const

export type TruckSubType = (typeof TRUCK_SUB_TYPES)[number]

export type Truck = {
  id: number
  name: string
  type: TruckType | null
}
